import { createSlice } from '@reduxjs/toolkit'
import { AppThunk } from 'store'
import { createApiAction, MiddlewareApiAction } from 'api'
import { userLoggedOut } from 'core/session/slices/session'
import { getStaRedirectLink } from 'core/staIntegration/api/staIntegrationService'
import { StaRedirectParams, RunningPlayer } from 'core/staIntegration/types'
import { StaLegacyPlayerState } from './types'

const initialState: StaLegacyPlayerState = {
  runningPlayer: RunningPlayer.None,
  initializing: false,
  playerOpenerLink: null,
}

const staLegacyPlayerSlice = createSlice({
  name: 'staLegacyPlayer',
  initialState,
  reducers: {
    playerInitializing(state) {
      state.initializing = true
    },
    surveyPlayerLinkReady(state, action) {
      state.initializing = false
      state.runningPlayer = RunningPlayer.Survey
      state.playerOpenerLink = action.payload.result?.getPlayerLink
    },
    cesPlayerLinkReady(state, action) {
      state.initializing = false
      state.runningPlayer = RunningPlayer.Ces
      state.playerOpenerLink = action.payload.result?.getPlayerLink
    },
    playerClose(state) {
      state.initializing = false
      state.runningPlayer = RunningPlayer.None
      state.playerOpenerLink = null
    },
  },
  extraReducers: builder => {
    builder.addCase(userLoggedOut, () => {
      return initialState
    })
  },
})

const { surveyPlayerLinkReady, cesPlayerLinkReady, playerInitializing, playerClose } =
  staLegacyPlayerSlice.actions

export { playerClose }
export default staLegacyPlayerSlice.reducer

export const runSurveyPlayer =
  (surveyId: string, courseRevisionId: string): AppThunk =>
  async dispatch => {
    dispatch(playerInitializing)

    const redirectParams: StaRedirectParams = {
      moduleName: null,
      pluginName: null,
      command: 'SURVEYVIEWER',
      courseId: courseRevisionId,
      surveyId: surveyId,
      isTL: 1,
      isResult: 'False',
    }

    const surveyLinkAction = createApiAction({
      apiCalls: {
        getPlayerLink: () => getStaRedirectLink(redirectParams),
      },
      payloadAction: surveyPlayerLinkReady,
      shouldShowGlobalLoading: true,
    })
    dispatch(surveyLinkAction as MiddlewareApiAction)
  }

export const runCesPlayer =
  (testId: string, scheduleId?: string): AppThunk =>
  async dispatch => {
    dispatch(playerInitializing)

    const redirectParams: StaRedirectParams = {
      moduleName: null,
      pluginName: null,
      command: 'CESPLAYER',
      cesTestId: testId,
      cesScheduleId: scheduleId || null,
    }

    const cesLinkAction = createApiAction({
      apiCalls: {
        getPlayerLink: () => getStaRedirectLink(redirectParams),
      },
      payloadAction: cesPlayerLinkReady,
      shouldShowGlobalLoading: true,
    })
    dispatch(cesLinkAction as MiddlewareApiAction)
  }

export const closePlayer = (): AppThunk => async dispatch => {
  dispatch(playerClose())
}
